'use strict';

function ProgressLine() {
  this.extends = [_ComponentDataBind];
  this.declaredClass = null;
  this.node = null;
  this.id = null;

  this.countSteps = 0;
  this.currentStep = 0;

  this._bar = null;

  this.init = function () {
    var _this = this;

    this._super();

    this._bar = document.createElement('div');
    this.node.appendChild(this._bar);
    this._updateStepValue();

    // listen to changes to this.value from _ComponentDataBind
    this.onDataBindUpdate('currentStep', function () {
      _this._updateStepValue();
    });
  };

  this.initAllReady = function () {
    this.node.style.display = 'block';
  };

  this.destroy = function () {
    this._super();
  };

  this._updateStepValue = function () {
    this._bar.style.width = 100 * this.currentStep / this.countSteps + '%'; // (this.node.offsetWidth * this.currentStep / this.countSteps) + 'px';
  };
}